<template>
  <div class="about-us-content-container">
    <!-- 数据展示区域 -->
    <div class="header-count-container">
      <div class="count-container wow bounceIn">
        <div class="value">
          <span>2.3</span>
          <span class="unit">万+</span>
        </div>
        <div class="label">
          <span>服务客户</span>
        </div>
      </div>
      <div class="count-container wow bounceIn" data-wow-delay="0.1s">
        <div class="value">
          <span>100</span>
          <span class="unit">+</span>
        </div>
        <div class="label">
          <span>支持业务场景</span>
        </div>
      </div>
      <div class="count-container wow bounceIn" data-wow-delay="0.2s">
        <div class="value">
          <span>10</span>
          <span class="unit">+</span>
        </div>
        <div class="label">
          <span>医院覆盖</span>
        </div>
      </div>
      <div class="count-container wow bounceIn" data-wow-delay="0.3s">
        <div class="value">
          <span>12.6</span>
          <span class="unit">万+</span>
        </div>
        <div class="label">
          <span>医疗档案</span>
        </div>
      </div>
    </div>
    <!-- 公司简介 -->
    <div class="company-introduct">
      <div class="title wow fadeInUp">
        <span>公司简介</span>
      </div>
      <div class="introduct">
        <p class=" wow fadeInUp">
          杭州栗鼠科技有限公司成立于2015年，是一家专业的软件制作策划公司。公司主要服务于中小医院，提供软件制作，网站设计制作建设，网络推广营销于一体的专业服务。公司以“创新”为核心价值，希望通过我们的专业水平和不懈努力，重塑中小医院的软件革新及网络形象，为企业产品推广，文化建设传播提供服务指导。
        </p>
        <p style="margin-top: 32px" class="wow fadeInUp">
          栗鼠和专业的医疗团队进行合作，深入了专业的医疗服务体系。以技术驱动产品力，打造最优质的互联网医疗平台。目前已服务于多家中小型医院，大大提升了医疗系统的协同力。栗鼠致力于成为国内外优秀的一站式医疗软件服务解决方案提供商。
        </p>
      </div>
    </div>
    <!-- 服务支持 -->
    <div class="service-support-container">
      <div class="title wow fadeInUp">
        <span>服务支持</span>
      </div>
      <div class="support-card-container">
        <div
          class="support-card-wrapper wow fadeInUp"
          v-for="(item,index) in supportData"
          :key="item.title"
          :data-wow-delay="`${(index + 1) / 10}s`"
        >
          <div class="logo">
            <img :src="item.logoUrl" alt="" />
          </div>
          <div class="card-title">
            <span>{{ item.title }}</span>
          </div>
          <div class="card-txt">
            <span>{{ item.txt }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 联系我们 -->
    <div class="contact-us-container">
      <img src="@/assets/images/contact-bg.png" alt="" />
      <div class="contact-us-card-container wow fadeInRight">
        <div class="card-title">
          <span>联系我们</span>
        </div>
        <div class="card-body">
          <div class="card-content-container">
            <div class="label">
              <img src="@/assets/images/icon-phone-white.png" alt="" />
              <span>公司电话</span>
            </div>
            <div class="value">
              <span>{{companyData.phone}}</span>
            </div>
          </div>
          <div class="card-content-container">
            <div class="label">
              <img src="@/assets/images/icon-location.png" alt="" />
              <span>公司地址</span>
            </div>
            <div class="value">
              <span>{{companyData.location}}</span>
            </div>
          </div>
          <div class="card-content-container">
            <div class="label">
              <img src="@/assets/images/icon-wx-white.png" alt="" />
              <span>扫码一对一服务</span>
            </div>
            <div class="qr-code">
                <!-- <img src="" alt=""> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      supportData: [
        {
          logoUrl: require("@/assets/images/icon-maintain.png"),
          title: "终身产品维护",
          txt: "为产品提供终身的技术服务支持",
        },
        {
          logoUrl: require("@/assets/images/icon-team.png"),
          title: "专业团队支持",
          txt: "专业技术团队，医疗机构团队提供专业支持",
        },
        {
          logoUrl: require("@/assets/images/icon-clock.png"),
          title: "7X24小时客服",
          txt: "快速业务响应能力，技术问题快速排查",
        },
        {
          logoUrl: require("@/assets/images/icon-tryout.png"),
          title: "产品免费试用",
          txt: "向客服申请获取产品免费体验资格",
        },
        {
          logoUrl: require("@/assets/images/icon-customize.png"),
          title: "个性化定制",
          txt: "针对不同目标客户，提供定制化的服务",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.about-us-content-container {
  .header-count-container {
    height: 150px;
    background: #065dea;
    display: flex;
    justify-content: center;
    padding: 0 10%;
    .count-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .value {
        font-family: PingFangSC-Medium;
        font-size: 40px;
        line-height: 56px;
        color: #ffffff;
        display: flex;
        .unit {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #ffffff;
          margin: 8px 0 0 4px;
          line-height: 24px;
        }
      }
      .label {
        margin-top: 4px;
        opacity: 0.7;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #ffffff;
      }
    }
  }
  .company-introduct {
    padding: 0 18%;
    height: 410px;
    background-image: linear-gradient(180deg, #ffffff 0%, #f9fafc 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      margin: 80px 0 40px;
      font-family: PingFangSC-Semibold;
      font-size: 30px;
      color: #222222;
    }
    .introduct {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #3c3d3f;
      letter-spacing: 0;
      line-height: 28px;
    }
  }
  .service-support-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      margin: 80px 0 50px;
      font-family: PingFangSC-Semibold;
      font-size: 30px;
      color: #222222;
    }
    .support-card-container {
      margin-bottom: 140px;
      width: 1100px;
      display: flex;
      justify-content: space-between;
      .support-card-wrapper {
        width: 200px;
        height: 260px;
        padding: 50px 29px 45px 29px;
        background: #ffffff;
        border: 1px solid #e9eef5;
        box-shadow: 0 2px 16px 0 rgba(71, 75, 82, 0.06);
        border-radius: 4px 4px 0 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .logo {
          img {
            width: 60px;
            height: 60px;
          }
        }
        .card-title {
          font-family: PingFangSC-Medium;
          font-size: 18px;
          color: #3c3d3f;
          letter-spacing: 0;
          text-align: center;
        }
        .card-txt {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #7b8799;
          letter-spacing: 0;
          text-align: center;
        }
      }
    }
  }
  .contact-us-container {
    position: relative;
    border-bottom: 1px solid #637385;
    img {
      width: 100%;
    }
    .contact-us-card-container {
      position: absolute;
      right: 10%;
      bottom: 10%;
      width: 380px;
      height: 540px;
      padding: 30px 40px 50px;
      background-image: linear-gradient(0deg, #119dfd 0%, #0764fb 100%);
      .card-title {
          margin-bottom: 6px;
        font-family: PingFangSC-Semibold;
        font-size: 30px;
        color: #ffffff;
        letter-spacing: 0;
      }
      .card-body {
        .card-content-container {
              padding-top: 24px;
          &:not(:last-child) {
            border-bottom: 1px solid #2fa7ff;
          }
          .label {
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            img {
              width: 24px;
              height: 24px;
              margin-right: 14px;
            }
            font-family: PingFangSC-Semibold;
            font-size: 18px;
            color: #ffffff;
          }
          .value {
            margin-bottom: 24px;
            padding-left: 38px;
            opacity: 0.7;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #ffffff;
            letter-spacing: 0;
          }
          .qr-code {
            margin-left: 38px;
            width: 120px;
            height: 120px;
            background: #ffffff;
            border-radius: 4px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/aboutUs/components/aboutUsContent.vue